


















import ContactUsLink from '@front-app/components/ContactUsLink.vue';
import { defineComponent } from '@vue/composition-api';
import { v4 } from 'uuid';
import { Tooltip as VueTooltip } from 'v-tooltip';

export default defineComponent({
	components: {
		VueTooltip,
		ContactUsLink,
	},
	props: {
		isEnhancedDashboard: Boolean,
	},
	setup(props) {
		const getCloseTriggers = (defaultTriggers: string[]) => {
			if (props.isEnhancedDashboard) {
				return [];
			}
			return defaultTriggers.filter((trigger) => trigger !== 'hover').concat('click');
		};
		return {
			getCloseTriggers,
			showGroup: v4(),
		};
	},
});
